import { getRailsClient } from "../client";
import { NotificationsResponse } from "./types";

const fetchUserNotifications = async (): Promise<NotificationsResponse> => {
  const client = getRailsClient();
  const route = "/api/internal_api/v1/notifications";

  const { data } = await client.get<NotificationsResponse>(route);
  return data;
};

const clearUserNotification = async (id: number): Promise<void> => {
  const client = getRailsClient();
  const route = `/api/internal_api/v1/notifications/${id}`;

  await client.delete(route);
};

const clearAllUserNotifications = async (): Promise<void> => {
  const client = getRailsClient();
  const route = `/api/internal_api/v1/notifications/destroy_all`;

  await client.delete(route);
};

//TODO: custom notifications

export { fetchUserNotifications, clearUserNotification, clearAllUserNotifications };
